<template>
    <BaseForm @submit="submitEmail">
        <template #title>{{ title }}</template>

        <template #before>
            Voor welk e-mailadres wil je je wachtwoord opnieuw instellen?
        </template>

        <template #content>
            <FieldValidator
                v-slot="{ field, meta, errors }"
                name="email"
            >
                <BaseFormField :errors="errors">
                    <BaseInput
                        v-bind="field"
                        type="email"
                        placeholder="E-mail"
                        :validator="meta"
                    />
                </BaseFormField>
            </FieldValidator>

            <div
                v-if="!!errorMessage"
                class="form__error"
            >
                {{ errorMessage }}
            </div>
        </template>

        <template #actions>
            <BaseButton
                type="button"
                @click.prevent="emit('backToLogin')"
            >
                Terug naar inloggen
            </BaseButton>

            <BaseButton
                type="submit"
                class="form__submit button--secondary"
            >
                Verzenden
                <template #after>
                    <BaseIcon icon="arrow-right" />
                </template>
            </BaseButton>
        </template>
    </BaseForm>
</template>

<script setup lang="ts">
import { useForm, Field as FieldValidator } from 'vee-validate';
import {
    STATUS,
    PASSWORD_RESET_TOO_MANY_ATTEMPTS,
} from '~/constants/errorMessages';

defineProps<{
    title?: string;
}>();

const emit = defineEmits(['emailSent', 'backToLogin']);

const errorMessage = ref<string|null>(null);

const { handleSubmit, values } = useForm<{ email: string }>({
    validationSchema: {
        email: 'required|email'
    }
});

const submitEmail = handleSubmit(async(formData) => {
    errorMessage.value = null;

    const { error } = await useFetchLaravel(
        '/v2.0/user/email-confirmation/resend',
        {
            method: 'POST',
            data: {
                email: values.email
            }
        }
    );

    if (error.value?.status === 429) {
        errorMessage.value = PASSWORD_RESET_TOO_MANY_ATTEMPTS;
    } else if (error.value) {
        errorMessage.value = STATUS['500'];
    } else {
        useSignUpStore().setEmail(formData.email);

        emit('emailSent');
    }
});
</script>
